import type { EventData } from '@backmarket/nuxt-module-tracking'

export function formatFunnelTrackingPayload(
  payload: Record<string, unknown>,
): EventData {
  const { nextStep: _nextStep, ...rest } = payload

  return Object.fromEntries(
    Object.entries(rest).map(([key, value]) => [
      key,
      Array.isArray(value) ? value.join('+') : value,
    ]),
  ) as EventData
}
